var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgParkingP = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 350,
  height: 333.331,
  viewBox: "0 0 350 333.331"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "parking_P_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 249.998h262.5V0H0z"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#43b02a",
  d: "m0 0 .008 333.33H350V0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#parking_P_svg__a)",
  transform: "matrix(1.33333 0 0 -1.33333 0 333.33)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M81.522 157.172h-9.655v41.956h9.655c14.185 0 26.19-5.514 26.19-21.47s-12.406-20.486-26.19-20.486m-2.372 63.63H44.28v-137.5h27.587v52.195H83.48c29.557 0 52.996 11.628 52.996 43.737 0 32.898-27.378 41.568-57.326 41.568M213.037 45.626l6.236 17.784h.123l6.24-17.784zm11.37 26.438h-9.77L197.84 28.95h8.953l3.77 9.882h17.482l3.708-9.88h9.578zm-45.32-20.322 18.47-22.79H186.25l-15.5 20.01h-.13v-20.01h-8.64v43.112h8.64V53.536l15.572 18.528h10.615zm-38.283 20.322h8.646V28.952h-8.647zm-25.814-19.95h-3.015v13.152h3.015c4.46 0 8.226-1.73 8.226-6.73s-3.892-6.422-8.226-6.422m-.73 19.95h-10.936V28.95h8.652v16.362h3.64c9.266 0 16.616 3.65 16.616 13.718 0 10.32-8.585 13.034-17.973 13.034"
}))));
export default SvgParkingP;